import HOWhatView from 'text!../views/ho-what.html';
import HOFireDetailsView from 'text!../views/ho-fire-details.html';
import HOWaterDetailsView from 'text!../views/ho-water-details.html';
import HOCrimeDetailsView from 'text!../views/ho-crime-details.html';
import HOBaseFnolWizardCtrl from 'edge/fnol/ho/controllers/HOBaseFnolWizardCtrl';
import HOWhatCtrl from 'edge/fnol/ho/controllers/HOWhatCtrl';
import HOFireDetailsCtrl from 'edge/fnol/ho/controllers/HOFireDetailsCtrl';
import HOWaterDetailsCtrl from 'edge/fnol/ho/controllers/HOWaterDetailsCtrl';
import HOCrimeDetailsCtrl from 'edge/fnol/ho/controllers/HOCrimeDetailsCtrl';

export default function () {
    var hoBaseFnolWizard = {
        name: 'hoBaseFnolWizard',
        parent: 'baseFnolWizard',
        abstract: true,
        controller: HOBaseFnolWizardCtrl,
        template: '<div ui-view></div>',
        data: {
            trackingUrl: ''
        }
    };

    return {
        hoBaseFnolWizard: hoBaseFnolWizard,
        hoWhat: {
            name: 'hoWhat',
            parent: hoBaseFnolWizard,
            template: HOWhatView,
            controller: HOWhatCtrl
        },
        hoFireDetails: {
            name: 'hoFireDetails',
            parent: hoBaseFnolWizard,
            template: HOFireDetailsView,
            controller: HOFireDetailsCtrl
        },
        hoWaterDetails: {
            name: 'hoWaterDetails',
            parent: hoBaseFnolWizard,
            template: HOWaterDetailsView,
            controller: HOWaterDetailsCtrl
        },
        hoCrimeDetails: {
            name: 'hoCrimeDetails',
            parent: hoBaseFnolWizard,
            template: HOCrimeDetailsView,
            controller: HOCrimeDetailsCtrl
        }
    };
}


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/fnol/ho/config/RouteConfig.js
// module id = 1548
// module chunks = 0